import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.qa.title',
  description: 'seo.qa.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
